export default {
  start: {
    type: "start",
    content: "所有人",
    properties: { title: "发起人", initiator: "ALL" }
  },
  approver: {
    type: "approver",
    content: "请设置审批人",
    properties: {
      title: "审批人",
      approvers: [], // 审批人集合
      assigneeType: "user", // 指定审批人
      formOperates: [], // 表单操作权限集合
      // 审批类型为自选 出现 optionalMultiUser optionalRange
      optionalMultiUser: true,
      downAddFlag: 1,
      optionalRange: "ALL", // USER<最多十个> / ALL / ROLE
      auditStyleType: 1, // 审批样式类型(1:默认审批样式,2:自定义审批样式)
      auditStyleId: "", // 审批样式id
      auditStyleName: "", // 审批样式名称
      auditMode: 3, // 审批方式(1:依次审批,2:会签,3:或签)
      flag: "1", // 审批样式标识(1:选择已有审批样式,2:新建审批样式)
      formStyle: {
        status: 0, //默认审批样式
        flag: 1,
        remark: "",
        remarkChecked: false,
        fileIds: "",
        fileIdsChecked: false,
        selectStyle: ""
      }
    }
  },
  copy: {
    type: "copy",
    content: "请设置抄送人",
    properties: {
      title: "抄送人",
      menbers: [],
      assigneeType: "user",
      downAddFlag: 1
    }
  },
  condition: {
    type: "condition",
    content: "请设置分支审批人",
    properties: { title: "分支审批人", conditions: [], initiator: null }
  },
  branch: { type: "branch", content: "", properties: {} },
  empty: { type: "empty", content: "", properties: {} }
};
